import { UserRole } from '../../common/EmployeeContext';

export enum CoachingCategory {
    Attendance = 'Attendance',
    Behavioral = 'Behavioral',
    Coaching = 'Coaching',
    Performance = 'Performance',
}

export enum CoachingStatus {
    Deleted = 'Deleted',
    Delivered = 'Delivered',
    Pending = 'Pending',
    ReadyForDelivery = 'Ready for Delivery',
    Rework = 'Rework',
}

export interface CoachingFile {
    // For S3 or other storage reference
    key: string;
    // Filename as displayed to users        
    name?: string;
    // File size in bytes   
    size?: number;
    // Download or preview URL if applicable     
    url?: string;
}

export interface CoachingRecord {
    // Basic Info
    id: string;
    agent?: string;
    supervisor?: string;
    user?: string;
    category?: string;
    reason?: string;
    action?: string;
    status?: string;
    date?: string;
    dueDate?: string;
    formId?: string;
    kustomerUrl?: string;
    hrNotes?: string;
    notes?: string;
    additionalNotes?: string;

    // HR / QA / Ownership
    hrbp: string;
    csqaReviewId: string;

    // File reference
    file?: CoachingFile;

    // Timestamps
    createdDate: string;
    createdTimestamp: number;
    approvalDate?: string;
    deliverDate?: string;
    hrReworkDate?: string;
    csReworkDate?: string;

    // Time metrics
    creationToReadyForDeliveryTime: number;
    pendingToReadyForDeliveryTime: number;
    pendingToReworkTime: number;
    reworkToPendingTime: number;

    // Flags
    deleted?: boolean;
}

export interface CoachingFetchResponse {
    payload: CoachingRecord[];
    maxResults?: boolean;
}

export interface CoachingDashboardProps {
    user: string;
    role?: UserRole;
    userPermissions: Set<string>;
}
